module.exports = __webpack_public_path__ + "static/media/Kerry Ko.47989eca.png";